import { render, staticRenderFns } from "./watertest.vue?vue&type=template&id=d9a80058&scoped=true"
import script from "./watertest.vue?vue&type=script&lang=js"
export * from "./watertest.vue?vue&type=script&lang=js"
import style0 from "./watertest.vue?vue&type=style&index=0&id=d9a80058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a80058",
  null
  
)

export default component.exports